import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { isMethodPage, isKiteUser, canApproveProduct } = {}) => ({
    root: {
      boxShadow: '0px 5px 17px rgba(48, 85, 107, 0.2)',
      borderRadius: 20,
      margin: 'auto',
      marginBottom: theme.spacing(2.5),
      width: '100%',
      [theme.breakpoints.down('md')]: {
        minHeight: 150,
        borderRadius: 10,
        '& span': {
          lineHeight: '12px !important',
        },
        '& > div:nth-child(1)': {
          paddingTop: theme.spacing(1.375),
          paddingBottom: theme.spacing(1.375),
        },
      },
    },
    buttons: {
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    description: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      '& span': {
        '&:nth-child(2)': {
          paddingLeft: theme.spacing(0.4),
          display: '-webkit-box',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          wordBreak: 'break-word',
          WebkitLineClamp: 1,
          WebkitBoxOrient: 'vertical',
        },
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: 0,
        flexWrap: 'wrap',
        '& span': {
          marginBottom: 0,
          '&:nth-child(2)': {
            paddingLeft: isMethodPage ? theme.spacing(0.4) : 0,
          },
        },
      },
      [theme.breakpoints.down('sm')]: {
        '& span': {
          paddingLeft: '0 !important',
        },
      },
    },
    orderInfo: {
      [theme.breakpoints.down('md')]: {
        '& span': {
          marginBottom: 0,
        },
      },
    },
    orderQty: {
      color: isKiteUser ? theme.palette.primary1 : theme.palette.primary2,
      fontWeight: 700,
      [theme.breakpoints.down('md')]: {
        '& span': {
          marginBottom: 0,
        },
      },
    },
    editIcon: {
      cursor: 'pointer',
      height: 12,
      width: 12,
      marginLeft: theme.spacing(1),
      marginTop: 6,
      '& path': {
        fill: theme.palette.primary1,
      },
    },
    statusContainer: {
      paddingBottom: theme.spacing(1),
      paddingRight: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        textAlign: canApproveProduct ? 'initial' : 'end',
      },
    },
    status: {
      color: '#929A92',
      fontSize: 14,
      fontWeight: 600,
      '&:first-letter': {
        textTransform: 'uppercase',
      },
      [theme.breakpoints.down('md')]: {
        marginLeft: 'auto',
        fontSize: 10,
        textAlign: 'end',
      },
    },
    actionButtons: {
      [theme.breakpoints.down('md')]: {
        columnGap: 20,
        justifyContent: 'flex-end',
        '& button': {
          height: 30,
          '&:nth-child(2)': {
            minWidth: 69,
          },
        },
      },
    },
  }),
);
